import { View } from '../../compiler'

import { colors } from '../../constants'
import { circleRadius } from '../../utils'

const ICON_SIZE = 24
const ICON_HALF = ICON_SIZE / 2

const UserDimensionValue = ({ bottom, left }) => {
  return (
    <View
      style={{
        position: 'absolute',
        left,
        bottom,
        transform: `translate(-${ICON_HALF}px, ${ICON_HALF}px)`,
        padding: 2,
        width: ICON_SIZE,
        height: ICON_SIZE,
        backgroundColor: 'white',
        borderRadius: circleRadius(ICON_SIZE)
      }}
    >
      <View
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: colors.brightBlue,
          borderRadius: 999
        }}
      />
    </View>
  )
}

export default UserDimensionValue
